export enum ProjectStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}
